import { Link } from '@/components/Link'
import styles from './AppButton.module.scss'
import dynamic from 'next/dynamic'
import { getAppConfig } from '@/config/config'

const config = getAppConfig()

type AppButtonProps = {
  variant: 'google' | 'apple'
}

const DynamicIcon = ({ variant }: AppButtonProps) => {
  let DynamicComponent

  if (variant === 'google') {
    DynamicComponent = dynamic(() => import('./logos/GooglePlayLogo'))
  } else {
    DynamicComponent = dynamic(() => import('./logos/AppStoreLogo'))
  }
  return <DynamicComponent />
}

const AppButton = ({ variant }: AppButtonProps) => {
  // TODO add the correct urls for the app stores

  return (
    <Link className={styles.button} href={config.store[variant] ?? '#'} target={'_blank'} aria-label={variant}>
      <DynamicIcon variant={variant} />
    </Link>
  )
}

export default AppButton
